<script lang="ts">
    import RewardsCurrency from "@apps/rewards/components/RewardsCurrency.svelte";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import { REWARDS_SPENDING_RULES_REWARD_TYPES } from "@apps/rewards/modules/SpendingRules/constants";
    import type { RewardsSpendingRulesEntity } from "@apps/rewards/modules/SpendingRules/models/RewardsSpendingRulesEntities";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    interface $$Slots {
        "fixed-amount-discount-reward": {
            amount: string;
        };
        "flexible-amount-discount-reward": {
            amount: string;
        };
        "fixed-percentage-discount-reward": {
            reward: { percents: number };
        };
        "flexible-percentage-discount-reward": {
            reward: { percentsY: number };
        };
        "gift-card-reward": {
            amount: string;
        };
        "free-product-reward": {
            reward: { percents: number };
        };
        "free-shipping-reward": object;
    }

    // Props
    export let reward: RewardsSpendingRulesEntity["rewards"][number];
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;
    export let maxDiscount: number | undefined = undefined;

    const {
        fixedAmountDiscount,
        flexibleAmountDiscount,
        fixedPercentageDiscount,
        flexiblePercentageDiscount,
        giftCard,
        productDiscount,
        shippingDiscount,
    } = REWARDS_SPENDING_RULES_REWARD_TYPES;
</script>

{#if reward.rewardType === fixedAmountDiscount}
    <RewardsCurrency
        amount={reward.amount}
        {currencyFormatter}
        {sanitizer}
        let:amount
    >
        <slot name="fixed-amount-discount-reward" {amount} />
    </RewardsCurrency>
{/if}

{#if reward.rewardType === flexibleAmountDiscount}
    <RewardsCurrency
        amount={maxDiscount ?? reward.amountY}
        {currencyFormatter}
        {sanitizer}
        let:amount
    >
        <slot name="flexible-amount-discount-reward" {amount} />
    </RewardsCurrency>
{/if}

{#if reward.rewardType === fixedPercentageDiscount}
    <slot
        name="fixed-percentage-discount-reward"
        reward={{ percents: reward.percents }}
    />
{/if}

{#if reward.rewardType === flexiblePercentageDiscount}
    <slot
        name="flexible-percentage-discount-reward"
        reward={{ percentsY: maxDiscount ?? reward.percentsY }}
    />
{/if}

{#if reward.rewardType === giftCard}
    <RewardsCurrency
        amount={reward.initialValue}
        {currencyFormatter}
        {sanitizer}
        let:amount
    >
        <slot name="gift-card-reward" {amount} />
    </RewardsCurrency>
{/if}

{#if reward.rewardType === productDiscount}
    <slot name="free-product-reward" reward={{ percents: reward.percents }} />
{/if}

{#if reward.rewardType === shippingDiscount}
    <slot name="free-shipping-reward" />
{/if}
